import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBarMenuItem',
  props: {
  path: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  selectedRoutePrefix: {
    type: [String, Array] as PropType<string | string[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const route = useRoute();

const activeRouteName = computed(() => String(route?.name || ''));

const prefixes = computed(() => {
  if (typeof props.selectedRoutePrefix === 'string') {
    return [props.selectedRoutePrefix];
  } else if (Array.isArray(props.selectedRoutePrefix)) {
    return props.selectedRoutePrefix;
  }
  return [];
});
const isActive = computed(() => prefixes.value.some((p: string) => routeStartsWith(p)));

function routeStartsWith(prefix: string) {
  return activeRouteName.value.startsWith(prefix);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass({ 'is-active': isActive.value })
  }, [
    _createVNode(_component_router_link, { to: __props.path }, {
      default: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, { icon: __props.icon }, null, 8, ["icon"])
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}
}

})